import { LaunchAdSerializer } from "@models/serializers/launchAdSerializer";
import { httpRequest } from "../../http";

export class CommandAddLaunchAds {
  async run(launchId: number, adIds: number[]) {
    const url = `${
      import.meta.env.VITE_API_PLATFORM_SERVICE_URL
    }api/v1/launch-ads/launch/${launchId}/`;

    const body = {
      ad_ids: adIds,
    };

    try {
      const response = await httpRequest<any>(url, {
        method: "POST",
        body: JSON.stringify(body),
      });
      return this.deserialize(response);
    } catch (error) {
      console.error("Error fetching data:", error);
      throw error;
    }
  }

  deserialize(data: any) {
    return new LaunchAdSerializer().deserializeList(data);
  }
}
